module.exports = __webpack_public_path__ + "assets/img/mosaic-columns-6.a94bfb44.jpg";